var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.formVisible
    ? _c(
        "div",
        [
          _c(
            "el-dialog",
            {
              directives: [{ name: "dragDialog", rawName: "v-dragDialog" }],
              attrs: {
                title: _vm.formTitle,
                visible: _vm.formVisible,
                width: "500px",
                "close-on-click-modal": false
              },
              on: {
                "update:visible": function($event) {
                  _vm.formVisible = $event
                }
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "dataForm",
                  attrs: {
                    model: _vm.addForm,
                    "label-width": "110px",
                    rules: _vm.formRules
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "中奖人:", prop: "Member" } },
                    [
                      _c("customerSelector", {
                        ref: "customerSelector",
                        model: {
                          value: _vm.addForm.Member,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "Member", $$v)
                          },
                          expression: "addForm.Member"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "身份证号:", prop: "Member.IdCode" } },
                    [
                      _c("el-input", {
                        attrs: {
                          "auto-complete": "off",
                          placeholder: "请输入身份证号"
                        },
                        model: {
                          value: _vm.addForm.Member.IdCode,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm.Member, "IdCode", $$v)
                          },
                          expression: "addForm.Member.IdCode"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "中奖奖品:", prop: "Award" } },
                    [
                      _c("awardSelector", {
                        ref: "awardSelector",
                        model: {
                          value: _vm.addForm.Award,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "Award", $$v)
                          },
                          expression: "addForm.Award"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "中奖时间:", prop: "WinningDate" } },
                    [
                      _c("el-date-picker", {
                        attrs: {
                          type: "date",
                          size: "small",
                          placeholder: "请选择中奖时间"
                        },
                        model: {
                          value: _vm.addForm.WinningDate,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "WinningDate", $$v)
                          },
                          expression: "addForm.WinningDate"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "是否已兑奖:", prop: "IsRedeem" } },
                    [
                      _c("el-switch", {
                        model: {
                          value: _vm.addForm.IsRedeem,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "IsRedeem", $$v)
                          },
                          expression: "addForm.IsRedeem"
                        }
                      })
                    ],
                    1
                  ),
                  _vm.addForm.IsRedeem
                    ? _c(
                        "el-form-item",
                        { attrs: { label: "兑奖日期:", prop: "RedeemDate" } },
                        [
                          _c("el-date-picker", {
                            attrs: {
                              type: "date",
                              size: "small",
                              placeholder: "请选择兑奖日期"
                            },
                            model: {
                              value: _vm.addForm.RedeemDate,
                              callback: function($$v) {
                                _vm.$set(_vm.addForm, "RedeemDate", $$v)
                              },
                              expression: "addForm.RedeemDate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-form-item",
                    { attrs: { label: "备注:", prop: "Description" } },
                    [
                      _c("el-input", {
                        attrs: {
                          type: "textarea",
                          rows: 6,
                          "auto-complete": "off",
                          placeholder: "请输入备注"
                        },
                        model: {
                          value: _vm.addForm.Description,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "Description", $$v)
                          },
                          expression: "addForm.Description"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer"
                },
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function($event) {
                          _vm.formVisible = false
                        }
                      }
                    },
                    [_vm._v("取消")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleSubmit }
                    },
                    [_vm._v("提交")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }